import { Language, Namespace, TFn } from "@racoon/i18n";

/**
 * Whole minutes a shift actually ran: fact start to fact end. Unset until it has
 * both, or when they are out of order.
 */
export const shiftDurationMinutes = (startedAt?: string, completedAt?: string) => {
  if (!startedAt || !completedAt) return undefined;
  const ms = new Date(completedAt).getTime() - new Date(startedAt).getTime();
  return Number.isFinite(ms) && ms >= 0 ? Math.floor(ms / 60_000) : undefined;
};

/**
 * "12 часов 45 мин": hours declined for the UI language. Hours are left out under
 * an hour, and minutes on a whole number of hours.
 */
export const formatShiftDuration = (minutes: number, t: TFn, lang: `${Language}`) => {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  const minutesLabel = `${rest} ${t(Namespace.Autopark, "units.minutesShort")}`;
  if (hours === 0) return minutesLabel;

  const form = new Intl.PluralRules(lang).select(hours);
  const unit =
    form === "one" ? "units.hoursOne" : form === "few" ? "units.hoursFew" : "units.hoursMany";
  const hoursLabel = `${hours} ${t(Namespace.Autopark, unit)}`;
  return rest === 0 ? hoursLabel : `${hoursLabel} ${minutesLabel}`;
};
